export const setToLS = (name, val) => {
  localStorage.setItem(name, JSON.stringify(val));
};

export const getFromLS = (name) => {
  return JSON.parse(localStorage.getItem(name));
};

export const removeFromLS = (name) => {
  localStorage.removeItem(name);
};

export const isLSHasItem = (name) => {
  return !!localStorage.getItem(name);
};

export const revertToCamelCase = (str) => {
  let res = '';
  if (!!str?.length) {
    res = str
      .split('_')
      .map((el) => el[0].toUpperCase() + el.slice(1))
      .join('');
  }
  return res;
};

export const createFile = async (url, type) => {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type: type,
  };
  return new File([data], url.split('/').at(-1), metadata);
};
